import React from 'react';

const Education = () => {
  return (
    <div className="education" id="education">
      <div className="sub-title text text-EN">Education</div>
      <div className="sub-title text text-UA">Навчання</div>

      {/* UE Udemy */}
      <div className="job-cont">
        <div className="job-title">
          Unreal Engine 5 C++ Inventory System / 
          <a
            href="https://www.udemy.com/certificate/UC-cb5c6120-c804-4550-a150-c765c9a5017e/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          December 2025
        </div>
        <div className="job-timeline text text-UA">
          Грудень 2025
        </div>
      </div>

      <div className="job-cont">
        <div className="job-title">
          Unreal Engine 5 - Gameplay Ability System - Top Down RPG / 
          <a
            href="https://www.udemy.com/certificate/UC-fe8b4eae-7fa1-43a6-96f0-83b08972173e/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          August 2024
        </div>
        <div className="job-timeline text text-UA">
          Серпень 2024
        </div>
      </div>

      <div className="job-cont">
        <div className="job-title">
          Unreal Engine 5: One Course Solution For Niagara VFX / 
          <a
            href="https://www.udemy.com/certificate/UC-3e893442-5f75-41a2-ae9c-0985359c3413/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          November 2025
        </div>
        <div className="job-timeline text text-UA">
          Листопад 2025
        </div>
      </div>

      <div className="job-cont">
        <div className="job-title">
          Unreal Engine 5: One Course Solution For Material / 
          <a
            href="https://www.udemy.com/certificate/UC-4bc87af1-96fb-4f65-a102-45198be15251/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          October 2025
        </div>
        <div className="job-timeline text text-UA">
          Жовтень 2025
        </div>
      </div>

      <div className="job-cont">
        <div className="job-title">
          Unreal Engine (C++ Development) / 
          <a
            href="https://www.udemy.com/certificate/UC-a6effa3c-4b18-49a1-a09d-d619562b766c/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          June 2022
        </div>
        <div className="job-timeline text text-UA">
          Червень 2022
        </div>
      </div>

      {/* Docker Udemy */}
      <div className="job-cont">
        <div className="job-title">
          Docker Mastery / 
          <a
            href="https://www.udemy.com/certificate/UC-ea095142-c5c3-4e29-b08f-54c120fcc139/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          November 2025
        </div>
        <div className="job-timeline text text-UA">
          Листопад 2025
        </div>
      </div>

      {/* Web Development Udemy */}
      <div className="job-cont">
        <div className="job-title">
          The Complete Full-Stack Web Development Bootcamp / 
          <a
            href="https://www.udemy.com/certificate/UC-cc0a5be8-32f5-4e45-8e36-285a74af8f6f/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          August 2024
        </div>
        <div className="job-timeline text text-UA">
          Серпень 2024
        </div>
      </div>

      {/* Python Udemy */}
      <div className="job-cont">
        <div className="job-title">
          The Complete Python Pro Bootcamp / 
          <a
            href="https://www.udemy.com/certificate/UC-cc8b7691-c04a-4095-b5c8-00a148f74cab/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          September 2024
        </div>
        <div className="job-timeline text text-UA">
          Вересень 2024
        </div>
      </div>

      {/* MLDL Udemy */}
      <div className="job-cont">
        <div className="job-title">
          TensorFlow for Deep Learning Bootcamp / 
          <a
            href="https://www.udemy.com/certificate/UC-169e9852-3ea8-4d33-a865-fdd4fe760fe5/"
          >
            Udemy
          </a>
        </div>
        <div className="job-timeline text text-EN">
          September 2025
        </div>
        <div className="job-timeline text text-UA">
          Вересень 2025
        </div>
      </div>

      {/* Robotics Udemy */}
      <div className="job-cont">
        <div className="job-title">
          ROS2 For Beginners / 
          <a
            href="https://www.udemy.com/certificate/UC-7a8c6caa-cf2b-46c2-9340-1a1619b672fb/"
          >
            Basic
          </a>
           / 
          <a
            href="https://www.udemy.com/certificate/UC-b0468b36-88b0-4096-93b1-48d740d48b8e/"
          >
            Gazebo
          </a>
           / 
          <a
            href="https://www.udemy.com/certificate/UC-b2fc063d-84aa-45c2-ba5f-dec3f3b5beaa/"
          >
            Action
          </a>
          / 
          <a
            href="https://www.udemy.com/certificate/UC-9dc22ad1-7196-41f9-bf7a-4d58432f0935/"
          >
            Nav2
          </a>
        </div>
        <div className="job-timeline text text-EN">
          December 2024 - November 2025
        </div>
        <div className="job-timeline text text-UA">
          Вересень 2025 - Листопад 2025
        </div>
      </div>

      {/* NTUU */}
      <div className="job-cont">
        <div className="job-title text text-EN">
          Faculty of Electronics / 
          <a href="https://kpi.ua/en/fel">
            NTUU “Igor Sikorsky Kyiv Polytechnic Institute”
          </a>
        </div>
        <div className="job-title text text-UA">
          Бакалавр факультету електроніки / 
          <a href="https://kpi.ua/en/fel">
            НТУУ "Київський політехнічний інститут імені Ігоря
            Сікорського"
          </a>
        </div>
        <div className="job-timeline text text-EN">
          September 2009 - June 2014 / Ukraine, Kyiv
        </div>
        <div className="job-timeline text text-UA">
          Вересень 2009 - Червень 2014 / Україна, Київ
        </div>
      </div>
    </div>
  );
};

export default Education;
